import * as React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "./dialog";
import { Button } from "./button";

interface SafetyDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onLeave: () => void;
  onStay: () => void;
  title?: string;
  description?: string;
}

export function SafetyDialog({
  open,
  onOpenChange,
  onLeave,
  onStay,
  title = "Caution: You have open changes",
  description = "You have unsaved changes that will be lost if you leave this page. Are you sure you want to continue?",
}: SafetyDialogProps) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-xl">
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
          <DialogDescription>{description}</DialogDescription>
        </DialogHeader>
        <DialogFooter className="flex justify-end gap-3 mt-4">
          <Button variant="ghost" onClick={onLeave}>
            Leave
          </Button>
          <Button onClick={onStay}>Back to page</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
